import { z } from 'zod';

/**
 * URL search-param schema for the document-extractions list page.
 *
 * All filter params travel through the URL — page derives FilterState
 * from these, so a refresh / back-forward / shared link reproduces the
 * view exactly. Persistence to the user_preferences row is wired in
 * `usePersistentDocFilters`. `searchTerm` is in the URL too so a shared
 * link reproduces the search query, but it's intentionally NOT a
 * persisted filter (ephemeral session state, not user preference).
 *
 * Dashboard drilldown bookkeeping (`from`, `dashFrom`, `dashTo`,
 * `dashPreset`, `dashLabel`) is here so a TypeScript drilldown URL
 * builder can `satisfies DocumentsSearch` its output and
 * the destination router validates the same key set the source page
 * sends.
 */
export const documentsSearchSchema = z.object({
  urgency: z.string().optional(),
  classification: z.string().optional(),
  referringProviderName: z.string().optional(),
  healthPlan: z.string().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  searchTerm: z.string().optional(),
  // Drilldown bookkeeping — present iff the user navigated here from
  // a dashboard tile.
  from: z.string().optional(),
  dashFrom: z.string().optional(),
  dashTo: z.string().optional(),
  dashPreset: z.string().optional(),
  dashLabel: z.string().max(80).optional(),
});

export type DocumentsSearch = z.infer<typeof documentsSearchSchema>;
